<template>
    <div class="page-content header-clear-medium">

        <div class="card card-style">
            <div class="card-body text-center">
                <h2>Khazanah</h2>
                <select class="mt-3 form-control w-50 mx-auto" @change="changeKhazanah()">
                   <option value="" disabled selected>Silahkan pilih kategori</option>
                    <option v-for="item in categories" :key="item.id" v-bind:value="item.id">{{ item.name }}</option>
                </select>
                <input class="mt-3 form-control w-50 mx-auto" placeholder="Pencarian" v-model="search">
            </div>

            <div class="card card-style">
                <div class="content mb-0">
                    <div class="row">
                        <div class="col-md-6 p-3 text-center" v-for="item in khazanahs" :key="item.id">
                            <router-link :to="{ name: 'khazanah.detail', params: {
                                id: item.id,
                                title: item.title
                            } }">
                                <div class="border border-5">
                                    <img :src="item.image_url" alt="" class="img-fluid">
                                    <h2 class="mt-3">{{ item.title }}</h2>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div v-if="next_page_url" class="text-center">
                    <button @click="loadMoreKhazanah()" class="btn gradient-highlight">Load More</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    name: 'Index',
    data() {
        return {
            category: null,
            search: '',
            categories: [],
            // khazanahs: [],
            isBusy: false
        }
    },
    created() {
        this.getCategory()
            .then(data => {
                this.categories = data.data
            })
    },
    methods: {
        ...mapActions('category', ['getCategory']),
        ...mapActions('khazanah', ['getKhazanah', 'getKhazanahLoadMore']),
        changeKhazanah() {
            this.getKhazanah(this.category)
                // .then(data => {
                //     this.khazanahs = data.data
                // })
        },
        loadMoreKhazanah() {
            let next_page = parseInt(this.page) + 1
            this.getKhazanahLoadMore(next_page)
        }
    },
    watch: {
        search(value) {
            if(this.category) {
                if(this.isBusy == false) {
                    this.isBusy = true
                    let category = this.category
                    this.getKhazanah([category, value])
                        .then(() => {
                            // this.khazanahs = data.data
                            this.isBusy = false
                        })
                }
            }
        }
    },
    computed: {
        ...mapState('khazanah', {
            khazanahs: state => state.khazanahs,
            page: state => state.page,
            next_page_url: state => state.next_page_url
        })
    }
}
</script>

<style scoped>
    .img-fluid {
        height: 250px !important;
    }
</style>